import { FlightShopStep } from "redmond";

const CORE_FLIGHTS_SHOP_ROUTES = {
  SHOP_ROUTE: "shop",
  RETURN_ROUTE: "return",
  REVIEW_ROUTE: "review",
  REVIEW_FARE_ROUTE: "fare",
};

export const getCoreFlightsShopSubPath = (
  flightShopStep: FlightShopStep,
): string => {
  switch (flightShopStep) {
    case FlightShopStep.ChooseDeparture:
      return ``;
    case FlightShopStep.ChooseReturn:
      return `${CORE_FLIGHTS_SHOP_ROUTES.RETURN_ROUTE}/`;
    case FlightShopStep.ReviewItinerary:
      return `${CORE_FLIGHTS_SHOP_ROUTES.REVIEW_ROUTE}/`;
    case FlightShopStep.FareDetails:
      return `${CORE_FLIGHTS_SHOP_ROUTES.REVIEW_ROUTE}/${CORE_FLIGHTS_SHOP_ROUTES.REVIEW_FARE_ROUTE}/`;
    default:
      return "";
  }
};

export enum CoreFlightsSearchQueryParams {
  ORIGIN = "origin",
  ORIGIN_REGION_TYPE = "originRegionType",
  DESTINATION = "destination",
  DESTINATION_REGION_TYPE = "destinationRegionType",
  DEPARTURE_DATE = "departureDate",
  RETURN_DATE = "returnDate",
  TRIP_CATEGORY = "tripCategory",
  STOPS_OPTION = "stopsOption",
  ADULT_COUNT = "adultsCount",
  CHILD_COUNT = "childrenCount",
  INFANT_IN_SEAT_COUNT = "infantsInSeatCount",
  INFANT_IN_LAP_COUNT = "infantsOnLapCount",
  NO_LCC = "noLCC",
  FARE_CLASS = "fareClass",
  IS_TRAVEL_APP = "isTravelApp",
  EXPANDED_FLIGHT_CARD = "expandedFlightCard",
  OPEN_FLIGHT_DETAILS_DIALOG = "openFlightDetailsDialog",
}
